import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
export const StatusIndicator = ({ status, pulse = true, label, className, ...props }) => {
    const colorMap = {
        healthy: 'bg-emerald-500',
        degraded: 'bg-amber-500',
        unhealthy: 'bg-rose-500',
        unknown: 'bg-slate-400',
    };
    const textMap = {
        healthy: 'text-emerald-700 dark:text-emerald-300',
        degraded: 'text-amber-700 dark:text-amber-300',
        unhealthy: 'text-rose-700 dark:text-rose-300',
        unknown: 'text-slate-600 dark:text-slate-400',
    };
    return (_jsxs("span", { className: cn('inline-flex items-center gap-2 text-xs font-medium', className), ...props, children: [_jsxs("span", { className: "relative flex h-2.5 w-2.5", children: [pulse && status === 'healthy' && (_jsx("span", { className: cn('absolute inline-flex h-full w-full animate-ping rounded-full opacity-75', colorMap[status]) })), _jsx("span", { className: cn('relative inline-flex h-2.5 w-2.5 rounded-full', colorMap[status]) })] }), label && _jsx("span", { className: textMap[status], children: label })] }));
};
StatusIndicator.displayName = 'StatusIndicator';
//# sourceMappingURL=StatusIndicator.js.map